import { setGeo } from './helpers';
import { IJsonQuery } from './types';

export function clearGeo(jsonQuery: IJsonQuery): () => IJsonQuery {
  return () => setGeo()(jsonQuery)([]);
}
